export default __webpack_public_path__ + "static/media/visa.136798be.svg";